<ng-container *transloco="let t;">
    <div class="admin-layout">
        <div class="app-login-body">

            <img class="login-screen-main-img" src="../../assets/app-assets/images/general/login-screen-main-img.svg" alt="">
            <img class="login-screen-pattren-img" src="../../assets/app-assets/images/general/login-pattern.svg" alt="">
            
            <div class="login-header d-flex justify-content-between">
                <div>
                    <div class="logo">
                        <img src="../../assets/app-assets/images/logo/logo-yellow.svg" alt="">
                    </div>
                    <p class="text clr-white fs-12">Customizable connectivity solutions that<br>matter to your business.</p>
                </div>
                <div class="login-page-lang">
                    <app-language-changer />
                </div>
            </div>

            <div class="row">
                <div class="col-md-6">
                </div>
                <div class="col-md-6">
                    <div class="card login-form">
                        <div class="card-body">
                            <div class="text-center mb-4">
                                <p class="title clr-primary xl font-m">{{t('loginCardHeader')}}</p>
                                <p class="text">{{t('loginCardSubHeader')}}</p>
                            </div>
                            <form [formGroup]="loginForm" (ngSubmit)="submit()" class="form flex flex-column"
                                novalidate>
                                <div class="form-container">
                                    <div class="field">
                                        <input formControlName="email" type="text" autocomplete="off" pInputText
                                            [placeholder]="t('emailPlaceHolder')">
                                    </div>
                                    <div class="field">

                                        <span class="p-input-icon-right">
                                            <input formControlName="password"
                                                [type]="showPassword ? 'text' : 'password'" autocomplete="off"
                                                pInputText [placeholder]="t('passwordPlaceHolder')">
                                            <i *ngIf="showPassword" class="pi pi-eye" (click)="showHide()"></i>
                                            <i *ngIf="!showPassword" class="pi pi-eye-slash" (click)="showHide()"></i>
                                        </span>
                                    </div>
                                </div>
                                <div class="button-container">
                                    <button type="submit" class="app-button btn-primary w-100" label="Login"
                                        [disabled]="disableLoginButton || !loginForm.valid">{{t('loginBtnText')}}
                                        <span style="margin-left: 65%; position: absolute;"><i
                                                *ngIf="showSubmitButtonLoader" style="float: right;"
                                                class="pi pi-spin pi-spinner"></i></span>
                                    </button>
                                </div>
                                <div class="text-end mt-3">
                                    <a routerLink="/forgot" class="text">{{t('forgotPassword')}}</a>
                                </div>
                                <button *ngIf="false" (click)="loginWithAD()" type="button"
                                    class="btn btn-microsoft w-100 mt-2"><img
                                        src="../../assets/app-assets/images/general/microsoft.png">Login with Microsoft
                                    Azure AD</button>
                            </form>
                        </div>

                    </div>
                </div>
            </div>
            <div class="login-footer">
                <p class="text text-white fs-12">{{t('SMEInABox')}}</p>
                <p class="text text-white fs-12">|</p>
                <p class="text text-white fs-12">{{latestYear}} {{t('loginFooterText')}}.</p>
            </div>
        </div>
    </div>
</ng-container>